import { IDeleteContratoUseCase } from "../../../presentation/useCases/delete/delete_contrato_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteContratoUseCase

export class DeleteContratoUseCase implements IDeleteContratoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteContrato(IdContrato: number): Promise<void> {
    await this.repository.deleteContrato(IdContrato);
  }
}
